var map = {
	"./24-7-protection.svg": "e597",
	"./Lock.svg": "168f",
	"./accepted.svg": "95f3",
	"./arrow-down-gray.svg": "5335",
	"./arrow-down-white.svg": "eb74",
	"./arrow-down.svg": "c874",
	"./arrow-right.svg": "cd8c",
	"./atention.svg": "5372",
	"./bag-promotion.svg": "6325",
	"./banner.svg": "6105",
	"./board-gray.svg": "0846",
	"./board.svg": "93c7",
	"./buy-empty.svg": "b44a",
	"./by-trade.svg": "84c3",
	"./by-tradeup.svg": "e029",
	"./by-tradeupgroup.svg": "bcf0",
	"./carbon-trophy.svg": "890d",
	"./card-visa.svg": "1a3f",
	"./card.svg": "5d4a",
	"./cardEmpty.svg": "c99f",
	"./cards.svg": "3c00",
	"./cart.svg": "daca",
	"./check-circle.svg": "cfcb",
	"./chevron-left.svg": "d0fe",
	"./chevron-right.svg": "88ee",
	"./chevron-up.svg": "bb5d",
	"./clock.svg": "755b",
	"./close.svg": "8b1b",
	"./devices-plus.svg": "7088",
	"./devices.svg": "0006",
	"./down-arrow.svg": "fcc4",
	"./easy.svg": "42eb",
	"./edit.svg": "daf0",
	"./elipse.svg": "eeb5",
	"./elo.svg": "334b",
	"./evaluate.svg": "e99c",
	"./eye.svg": "7364",
	"./feature-gray.svg": "93ad",
	"./feature.svg": "142e",
	"./group21.svg": "95c9",
	"./group8.svg": "933c",
	"./hipercard.svg": "cdd3",
	"./icon-buy-empty.svg": "bc2a",
	"./icon-by-empty-red.svg": "411e",
	"./icon-by-empty-white.svg": "70b8",
	"./icon-login-red.svg": "c073",
	"./icon-login-white.svg": "4d01",
	"./icon-login.svg": "5885",
	"./icon-verify.svg": "38ac",
	"./icon-whats-app.svg": "91f6",
	"./key-password.svg": "4198",
	"./lock-gray.svg": "ee03",
	"./locker.svg": "938b",
	"./login-gray.svg": "a436",
	"./login.svg": "ca2f",
	"./mao-effect.svg": "383b",
	"./mastercard.svg": "8302",
	"./mcafee-logo.svg": "8d08",
	"./mobile.svg": "0df4",
	"./password.svg": "b009",
	"./pin.svg": "862b",
	"./point-blue.svg": "5d38",
	"./point.svg": "7c2f",
	"./safe.svg": "ce81",
	"./shield-white.svg": "ace8",
	"./single-check.svg": "3d94",
	"./trofeu-check.svg": "055f",
	"./vector.svg": "d80e",
	"./visa.svg": "30e2",
	"./warning-circle-.svg": "b97b",
	"./warning.svg": "daa9",
	"./wifi.svg": "4351"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";